export default __webpack_public_path__ + "static/media/icon_arrow_down.714ab152.svg";